import React from "react";
import styles from "./NotificationContents.module.scss";
import successImg from "../../images/circle-selected.svg";
import infoImg from "../../images/info-circle.svg";
import warnImg from "../../images/warning.svg";
import errorImg from "../../images/error.svg";
import crossImg from "../../images/crossGray.svg";

export type NotificationOpts = {
  id?: string;
  linkText?: string;
  linkUrl?: string;
  buttonText?: string;
  buttonHandler?: () => void;
  autoDismiss?: number;
};

type OwnProps = {
  severity: string;
  message: string;
  buttonText?: string;
  opts?: NotificationOpts;
};

const getimage = (severity: string | undefined) => {
  const image =
    severity === "success"
      ? successImg
      : severity === "info"
      ? infoImg
      : severity === "warning"
      ? warnImg
      : severity === "error"
      ? errorImg
      : undefined;
  return image;
};

const injectLinkToMessage = (message: string, linkText?: string, linkUrl?: string) => {
  if (!linkUrl) {
    return message;
  } else {
    const parts = message.split("%%");

    return parts.length == 1 ? (
      <div>
        <span className="new-line">{parts[0]}</span>
        <br />
        <a id="NotificationLink" href={linkUrl}>
          {linkText}
        </a>
      </div>
    ) : (
      <div>
        <span className="new-line">{parts[0]}</span>
        <a id="NotificationLink" href={linkUrl}>
          {linkText}
        </a>
        <span className="new-line">{parts[1]}</span>
      </div>
    );
  }
};

const NotificationContents = ({ severity, message, opts }: OwnProps): JSX.Element => {
  const notificationId = opts?.id ?? "NotificationText";
  return (
    <div className={styles.NotificationContents}>
      <img className={styles.SeverityImg} src={getimage(severity)} alt={severity} />
      <div id={notificationId} className={styles.NotificationText}>
        {injectLinkToMessage(message, opts?.linkText, opts?.linkUrl)}
        {opts?.buttonText && <button onClick={opts.buttonHandler}>{opts.buttonText}</button>}
      </div>
      {opts?.autoDismiss !== 30000 && (
        <img className={styles.DismissImg} src={crossImg} alt={"Dismiss"} />
      )}
    </div>
  );
};

export default NotificationContents;
